<template>
  <generic-modal
    :title="$t('email configuration')"
    icon="settings"
    image="/images/icons/email.png"
    v-on:destroy="destroy"
    v-bind:on_finished="this.finished"
  >
    <div class="description">
      <div class="ui form">
        <div class="fields">
          <div class="eight column wide field">
            <label>{{ $t("name") }}</label>
            <input type="text" name="name" placeholder="" v-model="name" />
          </div>
          <div class="four column wide field">
            <label>{{ $t("provider") }}</label>
            <div class="ui selection dropdown" ref="provider_dropdown">
              <input type="hidden" name="provider" />
              <i class="dropdown icon"></i>
              <div class="default text"></div>
              <div class="menu">
                <div class="item" data-value="">
                  {{ $t("select one") }}
                </div>
                <div class="item" data-value="nodemailer">
                  {{ $t("nodemailer") }}
                </div>
                <div class="item" data-value="mandrill">
                  {{ $t("mandrill") }}
                </div>
                <div class="item" data-value="outlook">
                  {{ $t("outlook") }}
                </div>
              </div>
            </div>
          </div>
          <div class="four column wide field">
            <div class="ui toggle checkbox" ref="is_default">
              <input type="checkbox" class="hidden" />
              <label>{{ $t("is default") }}</label>
            </div>
          </div>
        </div>
      </div>
      <div class="ui dividing header" v-if="provider">
        {{ $t("provider info") }}
      </div>
      <nodemailer
        :selected_configuration="selected_configuration"
        ref="nodemailer"
        v-if="provider == 'nodemailer'"
      />
      <mandrill
        :selected_configuration="selected_configuration"
        ref="mandrill"
        v-if="provider == 'mandrill'"
      />
      <outlook
        :selected_configuration="selected_configuration"
        ref="outlook"
        v-if="provider == 'outlook'"
      />
    </div>
  </generic-modal>
</template>

<script>
import { local_api } from "@/utils";
import filters from "@/filters";
import GenericModal from "@/components/GenericModal";
import Nodemailer from "./Nodemailer.vue";
import Outlook from "./Outlook.vue";
import Mandrill from "./Mandrill.vue";

export default {
  name: "EmailModal",
  filters: filters,
  components: {
    "generic-modal": GenericModal,
    Nodemailer,
    Mandrill,
    Outlook,
  },
  computed: {},
  props: { selected_configuration: Object },
  data() {
    return {
      name: "",
      is_default: false,
      provider: "",
      setup: {},
    };
  },
  methods: {
    finished() {
      let vm = this;
      return new Promise(function(resolve, reject) {
        let setup = {};
        if (vm.provider == "nodemailer") setup = vm.$refs.nodemailer.getSetup();
        else if (vm.provider == "mandrill")
          setup = vm.$refs.mandrill.getSetup();
        else if (vm.provider == "outlook") setup = vm.$refs.outlook.getSetup();
        setup.provider = vm.provider;
        local_api(vm, "post", "/settings/messaging/do-save-email", {
          i: vm.selected_configuration
            ? vm.selected_configuration.uuid
            : undefined,
          s: setup,
          n: vm.name,
          d: vm.is_default,
        })
          .then((r) => {
            vm.$emit("succedded", r);
            resolve(r);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    destroy() {
      this.$emit("destroy");
      this.$destroy();
    },
  },
  created() {},
  mounted() {
    let vm = this;

    /**
     * Init checkebox
     */
    window.jQuery(vm.$refs.is_default).checkbox({
      onChange() {
        vm.is_default = window
          .jQuery(vm.$refs.is_default)
          .checkbox("is checked");
      },
    });

    /**
     * Dropdown initialization
     */
    window.jQuery(vm.$refs.provider_dropdown).dropdown({
      onChange(value) {
        vm.provider = value;
      },
    });

    /**
     * Set stored values
     */
    if (vm.selected_configuration) {
      vm.name = vm.selected_configuration.name;
      if (vm.selected_configuration.setup.provider)
        window
          .jQuery(vm.$refs.provider_dropdown)
          .dropdown("set selected", vm.selected_configuration.setup.provider);
      if (vm.selected_configuration.is_default)
        window.jQuery(vm.$refs.is_default).checkbox("set checked");
    }
  },
  watch: {},
};
</script>
